import Select from 'react-select';
import { ReactComponent as DoubleChevronLeft } from '../../assets/Icons/chevron/Double-Chevron-Left.svg';
import { ReactComponent as DoubleChevronRight } from '../../assets/Icons/chevron/Double-Chevron-Right.svg';
import { ReactComponent as ChevronLeft } from '../../assets/Icons/chevron/Chevron-Left.svg';
import { ReactComponent as ChevronRight } from '../../assets/Icons/chevron/Chevron-Right.svg';
import { Dispatch, SetStateAction, MouseEvent, useEffect, useState, ReactNode } from 'react';
import { SelectionOption } from '../../utils/types';



export default function Pagination({
    setItemsPerPage,
    setCurrentPage,
    currentPage,
    startIndex,
    endIndex,
    total,
    totalPages,
    paginate,
}: {
    setItemsPerPage: Dispatch<SetStateAction<number>>,
    setCurrentPage: Dispatch<SetStateAction<number>>,
    currentPage: number,
    startIndex: number,
    endIndex: number,
    total: number,
    totalPages: number,
    paginate: (pageNumber: number, itmsPerPage?: number) => void,
}) {
    const [ perPageOptions, setPerPageOptions ] = useState<SelectionOption[]>([]);
    const [ selectedOption, setSelectedOption ] = useState<SelectionOption>({ value: 10, label: 10 });
    const [ btns, setBtns ] = useState<{
        icon: ReactNode,
        action: (e:MouseEvent<HTMLButtonElement>) => void,
        isDisabled: boolean,
    }[]>([])

    useEffect(() => {
        setPerPageOptions([
            {
                value: '10',
                label: '10',
            },
            {
                value: '20',
                label: '20',
            },
            {
                value: '50',
                label: '50',
            },
            {
                value: total.toString(),
                label: 'All',
            },
        ])
    }, [total]);

    useEffect(() => {
        setBtns([
            {
                icon: <DoubleChevronLeft />,
                action: (e: MouseEvent<HTMLButtonElement>) => {
                    e.preventDefault();
                    paginate(1);
                },
                isDisabled: currentPage === 1 ? true : false,
            },
            {
                icon: <ChevronLeft />,
                action: (e: MouseEvent<HTMLButtonElement>) => {
                    e.preventDefault();
                    paginate(currentPage-1);
                },
                isDisabled: currentPage === 1 ? true : false,
            },
            {
                icon: <ChevronRight />,
                action: (e: MouseEvent<HTMLButtonElement>) => {
                    e.preventDefault();
                    paginate(currentPage+1);
                },
                isDisabled: currentPage === totalPages ? true : false,
            },
            {
                icon: <DoubleChevronRight />,
                action: (e: MouseEvent<HTMLButtonElement>) => {
                    e.preventDefault();
                    paginate(totalPages);
                },
                isDisabled: currentPage === totalPages ? true : false,
            },
        ])
        //eslint-disable-next-line
    }, [currentPage, totalPages]);

    const handleChangeItemsPerPage = (e: any) => {
        paginate(currentPage, e.value);
        setItemsPerPage(e.value);
        setSelectedOption(e);
    }


    return (
        <div className='flex justify-end rounded-bl rounded-br'>
            <div className='flex justify-end items-center rounded gap-10'>
                <div className='flex justify-center items-center gap-3 text-default'>
                    <p>Results per page</p>
                    {perPageOptions && <Select 
                        menuPlacement='top' 
                        styles={{
                            control: (baseStyles, state) => ({
                                ...baseStyles,
                                borderColor: state.isFocused ? '#006D77' : '#C1C7CD',
                                width: '100%',
                                height: 40,
                                borderRadius: '8px',
                                boxShadow: 'none',
                                '&:hover': {
                                    borderColor: '#006D77',
                                    cursor: 'pointer'
                                }
                            }),
                            valueContainer: (baseStyles, state) => ({
                                ...baseStyles,
                                padding: '0 12px',
                            })
                        }}
                        aria-label='pagination-selection' 
                        options={perPageOptions}
                        onChange={handleChangeItemsPerPage}
                        value={selectedOption}
                    />}
                </div>
                <p className='text-default'>{startIndex}-{currentPage === totalPages ? total : endIndex} of {total}</p>
                <div className='flex justify-center items-center gap-3'>
                    {btns.map((btn, i) => (
                        <button 
                            key={i}
                            onClick={btn.action} 
                            disabled={btn.isDisabled} 
                            className={`bg-white border ${btn.isDisabled ? 'hover:text-default hover:border-outline opacity-50' : 'hover:text-primary hover:border-primary opacity-100'} text-default transition-all border-outline p-3 rounded-lg flex justify-center items-center`}
                        >
                            <div className='w-[18px] h-[18px]'>{btn.icon}</div>
                        </button>
                    ))}
                </div>
            </div>
        </div>
    )
}